import { AxiosResponse } from "axios";
import _ from "lodash";
import { IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import { CutType, AllowedCut } from "@/services/models-service";
import request from "@/utils/request";
import { IMonth } from "@/constants";


export const route_ns = `cut`;

export interface IAcceptedMonth extends IMonth {
  isAccepted: boolean
}

interface AcceptDataBlockFlags {
  [key: number]: boolean
}

interface IAcceptChangesData {
  [key: number]: AcceptDataBlockFlags
}

export interface IAcceptChanges {
  months: number[],
  cut_id: string
  data: IAcceptChangesData
}

class CutService {
    public current: CutType | null = null;
    // Флаг - признак акцептирования срезки
    public acceptIsChanged:boolean = false;
    // Список внесённых изменений при акцептировании срезки
    public acceptChanges: IAcceptChanges | null;
    public isEditMode: boolean = false;
    public crud = base_ds.getBaseCrud(route_ns);
    public data_source = base_ds.getBaseDataSource(route_ns);

    public setCurrent(value: CutType) {
      this.current = value;
    }

    public SetCutAcceptChanges(data: IAcceptChanges) {
      this.acceptIsChanged = true;
      this.acceptChanges = data || null;

      setTimeout(() => {
        // Сброс флага нужно производить прямо здесь, если вебсокет-оповещение придёт, когда польз-ль будет на странице,
        // где нет подписки на изменение acceptIsChanged, то это флаг не будет сброшен в false,
        // что приведёт к тому, что триггер в Watch не отработает снова
        this.acceptIsChanged = false;
      }, 200)
    }

    public async save(entity: CutType): Promise<IResponseResult<CutType>> {
      const response: AxiosResponse["data"] = await this.crud.save(entity);
      if (response) {
        return { data: response.data as CutType };
      } else {
        return { data: null, message: "" };
      }
    }

    public async get(): Promise<IResponseResult<CutType[]>> {
      const response: AxiosResponse["data"] = await this.crud.get();
      if (response && response.data) {
        return {data: response.data as CutType[] };
      } else {
        return { data: null, message: "" };
      }
    }

    public async getById(entity: string): Promise<IResponseResult<CutType>> {
      const response: AxiosResponse["data"] = await this.crud.get_by_id(entity);
      if (response) {
        return {data: response, message: ""};
      } else {
        return { data: null, message: "" };
      }
    }

    public async getWithFilter(year_id: string): Promise<IResponseResult<CutType[]>> {
      if (!year_id) {
        return { data: null };
      }
        const route = route_ns+`?filter=["id_year","=","${year_id}"]`;
        const response: AxiosResponse["data"] = await request({
            url: route,
            method: "get",
          });
        if (response) {
          return response;
        } else {
          return { data: null };
        }
      }

  public async getWithAccepts(year_id: string) {
    if (!year_id) {
      return { data: null };
    }
    const url = `${route_ns}/with_accepts?filter=["id_year","=","${year_id}"]`;
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response) {
      result = response;
    }
    return result;
  }

  public async getForAdmin(year_id: string) {
    if (!year_id) {
      return { data: null };
    }
    const url = `${route_ns}/for_admin?filter=["id_year","=","${year_id}"]`;
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response) {
      result = response.data;
    }
    return result;
  }

    public async saveOrderList(entity: CutType[]): Promise<IResponseResult<CutType[]>> {
      const route = route_ns + "/orderlist";
      const response: AxiosResponse["data"] = await request({
        url: route,
        method: "post",
        data: {data: entity}
      });
      if (response) {
        return { data: response.data as CutType[] };
      } else {
        return { data: null, message: "" };
      }
    }

    public async put(entitys: CutType[]): Promise<IResponseResult<CutType>> {
      const response: AxiosResponse["data"] = await request({
        url: route_ns,
        method: "put",
        data: {data: entitys},
      });
      if (response) {
        return { data: response.data as CutType };
      } else {
        return { data: null, message: "" };
      }
    }

    public async getAllowedCuts(id_eco_version: number | null, id_year: string, id_cut: string, objects: any): Promise<IResponseResult<AllowedCut[]>> {
        if (!id_year || !id_cut) {
          return { data: null };
        }
        let data = {id_eco_version: id_eco_version, id_year: id_year, id_cut: id_cut, objects: objects};
        const route = route_ns+`/allowable_cuts`;
        const response: AxiosResponse["data"] = await request({
            url: route,
            method: "post",
            data: data
          });
        if (response) {
          return {data: response};
        } else {
          return { data: null };
        }
    }

    public async getCopyPermissions(id_cut: string | number, id_copy_cut: string,
                                    all_filials: boolean, filials: string[] | null, objects: string[] | null,
                                    id_eco_version: number, copy_id_eco_version: number,
                                    id_year: string, copy_id_year: string) {
      if (!id_cut || !id_copy_cut) {
        return { data: null };
      }
      let data = {
        id_cut: id_cut,
        id_copy_cut: id_copy_cut,
        all_filials: all_filials,
        filials: filials,
        objects: objects,
        id_eco_version: id_eco_version,
        copy_id_eco_version: copy_id_eco_version,
        id_year: id_year,
        copy_id_year: copy_id_year
      };

      const route = route_ns+`/allowable_copy_data`;
      const response: AxiosResponse["data"] = await request({
          url: route,
          method: "post",
          data: data,
          timeout: 120000,
        });
      if (response) {
        return {data: response};
      } else {
        return { data: null };
      }
    }

    public async deleteAndReorded(id_cut: string | number, ordered_cuts: CutType[], id_year: string) {
      if (!id_cut) {
        return { data: null };
      }
      let data = {id_cut: id_cut, ordered_сuts: ordered_cuts, id_year: id_year};
      const route = route_ns+`/delete_and_reorded`;
      const response: AxiosResponse["data"] = await request({
          url: route,
          method: "post",
          data: data
        });
      let result = [];
      if(response) {
        result = response;
      }
      return result;
    }

  }

  export default new CutService();
